import { FC } from 'react'
import Layout from 'components/Layout/Layout'
import WholesalerOperationTemplate from 'components/Templates/WholesalerOperationTemplate'

const WholesalerOperation: FC = () => {
  return (
    <Layout title={'問屋登録・編集'} page="WholesalerOperation">
      <WholesalerOperationTemplate />
    </Layout>
  )
}

export default WholesalerOperation
